import { print } from "graphql";

import {
    Pricings,
    PricingsQueryVariables,
    PricingsQuery,
    PricingPlanFragment,
    PricingPlanCompareFeaturesItemFragment,
    PricingPlanAdditionalFeaturesItemFragment,
    PricingPlanCallToActionItemFragment,
    PricingPlanComparePlansItemFragment,
    PricingPlanMicroCtaFragment,
    PricingPlanHighlightedFeatureItemFragment,
    RelevantPlanFragment,
    FeatureAdditionalInformationFragment
} from "../../graphql-types";

import { graphql } from "./../../../src/graphql";

export type PricingContentResponse = PricingsQuery;
export type PricingContent = PricingPlanFragment;
export type PlanAdditionalDetails = PricingPlanAdditionalFeaturesItemFragment;
export type Features = PricingPlanCompareFeaturesItemFragment;
export type PricingPlanComparison = PricingPlanComparePlansItemFragment;
export type PricingPlanComparisonCta = PricingPlanMicroCtaFragment;
export type ContentPlatformHighlightedFeature =
    PricingPlanHighlightedFeatureItemFragment;
export type CallToAction = PricingPlanCallToActionItemFragment;
export type RelevantPlan = RelevantPlanFragment;
export type FeatureAdditionalInformation = FeatureAdditionalInformationFragment;

export type { PricingsQueryVariables };
export const GET_PRICING_CONTENT = graphql(print(Pricings));
